import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { AccesoService } from '../../acceso/acceso.service';
import { LocalService } from '../../storage/localService';
import { filter, pluck } from 'rxjs/operators';
import { SessionStorageService } from '../../storage/sessionStorage.service';
import { Observable } from 'rxjs';

import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ServifinCreditoService {
  readonly urlBase = environment.rutaBase;
  header: HttpHeaders;
  idEmpresa_Factor: any;
  message: Observable<any>;

  constructor(
    private http: HttpClient,
    private accesoService: AccesoService,
    private sessionStorageService: SessionStorageService,
    private localService: LocalService
  ) {
    this.header = this.accesoService.desencriptarTOKEN();
    this.datoStorage();
  }

  datoStorage() {
    this.message = this.sessionStorageService.storageChange$.pipe(
      filter(({ storageArea }) => storageArea === 'sessionStorage'),
      filter(({ key }) => key === '1cefada07eb9'),
      pluck('value')
    );
    this.message.subscribe(val => this.idEmpresa_Factor = val - this.localService.getJsonValue('numeroRandom'));
    if (this.idEmpresa_Factor === undefined) {
      this.idEmpresa_Factor = Number(sessionStorage.getItem('1cefada07eb9')) - this.localService.getJsonValue('numeroRandom');
    }
  }

  calcular(body: any) {
    return this.http.post(`${this.urlBase}/CreditoServifinCalc?idEmpresa_Factor=${this.idEmpresa_Factor}`, body, { headers: this.header });
  }

  generarPdf(cotizacion: any, tipo: string) {
    const payload = Object.assign({}, cotizacion, { tipo });
    return this.http.post(`${this.urlBase}/CreditoServifinPdf?idEmpresa_Factor=${this.idEmpresa_Factor}`, payload, { headers: this.header })
      .pipe(map((res: any) => {
        const data = res.data || res;
        const b64 = data.pdf_base64;
        const raw = atob(b64);
        const arr = new Uint8Array(raw.length);
        for (let i = 0; i < raw.length; i++) {
          arr[i] = raw.charCodeAt(i);
        }
        return new Blob([arr], { type: 'application/pdf' });
      }));
  }
}
